import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import getSchema from "../../lib/api/getSchema";
import EguPopInputMaterialDialog from "../dialogTypes/EguPopInputMaterialDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function EguPopInputMaterialButton(props) {

    const { id, onSelectMst, onUpdateMaster, onSuccess, customizeErrorMsgCallback, onTrigger, ...others } = props;

    const [open, setOpen] = useState(false);
    const [schema, setSchema] = useState();

    const { t } = useTranslation();

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("EguPopProductManageDetail");

            if (mounted && schema) {

                let modifiedSchema = { ...schema }
                modifiedSchema.columns = [{
                    name: "inputQty",
                    nullable: "YES",
                    required: true,
                    type: "float",
                    formItemType: 'float',
                    Immediately: true
                }, {

                    name: "lineNo",
                    type: "varchar(50)",
                    nullable: "NO",
                    formGroup: 0,
                    formOrder: 4,
                    readonly: true,

                },{
                    name: "bringMaterialDate",
                    type: "DATETIME(6)",
                    nullable: "NO",
                    required: false,
                    default: null,
                    // formGroup: 1,
                    formOrder: 5,
                    // hideInForm: true,
                    formItemType: "date",
                }]
                setSchema(modifiedSchema)

            }

        })();

        return (() => {
            mounted = false;
        });

    }, []);

    const onOpen = () => {
        setOpen(true);
        onTrigger(true)
    }

    const onClose = () => {
        setOpen(false)
        onTrigger(false)
    }

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg)
        }
    }

    return (
        <>
            <CreateRecordButtonLayout createButtonName={"InputMaterial"} id={id + "-create-materialInput-button"} onClick={onOpen} {...others} />
            <EguPopInputMaterialDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.materialInput`) : ""}
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                onSelectMst={onSelectMst}
                onUpdateMaster={onUpdateMaster}
            />
        </>
    )
}

export default EguPopInputMaterialButton;